<template>
  <div class="home">
    <Survey v-if="survey" :siteName="siteName" :ticketId="ticketId" :language="language" :requesterId="requesterId" :survey="survey" :initialRating="rating" />
    <Cancel v-if="cancel" :siteName="siteName" :ticketId="ticketId" :language="language" :requesterId="requesterId" :cancel="cancel" />
    <SolvedTicket v-if="solve" :siteName="siteName" :ticketId="ticketId" :language="language" :requesterId="requesterId" />
  </div>
</template>

<script>
// @ is an alias to /src
import SolvedTicket from '@/components/SolvedTicket.vue';
import Cancel from '@/components/Cancel.vue';
import Survey from '@/components/Survey.vue';

export default {
  name: 'Home',
  data() {
    return { siteName: '', ticketId: '', language: '', requesterId: '', cancel: false, survey: false, solve: true, rating: '' };
  },
  methods: {
    getVariables() {
      this.siteName = this.$route.query.siteName ? this.$route.query.siteName : null;
      this.ticketId = this.$route.query.ticketId ? this.$route.query.ticketId : null;
      this.language = this.$route.query.language ? this.$route.query.language : null;
      this.requesterId = this.$route.query.code ? this.$route.query.code : null;
      this.cancel = !!this.$route.query.cancel;
      this.survey = !!this.$route.query.survey;
      this.solve = !this.$route.query.cancel && !this.$route.query.survey;
      this.rating = this.$route.query.linkId === 'CSATGoodClick' ? 'Good' : this.$route.query.linkId === 'CSATBadClick' ? 'Bad' : null;
    },
  },
  created() {
    this.getVariables();
  },
  components: {
    SolvedTicket,
    Cancel,
    Survey,
  },
};
</script>
